import { CollectedAnswer } from "../types/training";

const getCollectedAnswersKey = (selectedProduct: string) => `collectedAnswers_${selectedProduct}`;

const getCompletedSectionsKey = (selectedProduct: string) => `completedSections_${selectedProduct}`;

const getCurrentSectionKey = (selectedProduct: string) => `currentSection_${selectedProduct}`;

export const getCollectedAnswers = (selectedProduct: string): CollectedAnswer[] => {
  try {
    return JSON.parse(
      localStorage.getItem(getCollectedAnswersKey(selectedProduct)) || "[]"
    ) as CollectedAnswer[];
  } catch (error) {
    console.error("Error reading collected answers:", error);
    return [];
  }
};

export const setCollectedAnswers = (selectedProduct: string, answers: CollectedAnswer[]) => {
  try {
    localStorage.setItem(getCollectedAnswersKey(selectedProduct), JSON.stringify(answers));
  } catch (error) {
    console.error("Error saving collected answers:", error);
  }
};

export const clearCollectedAnswers = (selectedProduct: string) => {
  try {
    localStorage.removeItem(getCollectedAnswersKey(selectedProduct));
  } catch (error) {
    console.error("Error clearing collected answers:", error);
  }
};

export const getCompletedSections = (selectedProduct: string) =>
  Number(localStorage.getItem(getCompletedSectionsKey(selectedProduct)) || 0);

export const setCompletedSections = (selectedProduct: string, completedSections: number) => {
  localStorage.setItem(getCompletedSectionsKey(selectedProduct), String(completedSections));
};

export const clearCompletedSections = (selectedProduct: string) => {
  localStorage.removeItem(getCompletedSectionsKey(selectedProduct));
};

export const getCurrentSection = (selectedProduct: string) =>
  Number(localStorage.getItem(getCurrentSectionKey(selectedProduct)) || 0);

export const setCurrentSection = (selectedProduct: string, sectionIndex: number) => {
  localStorage.setItem(getCurrentSectionKey(selectedProduct), String(sectionIndex));
};
